import { HTMLAttributes } from "react";
import classNames from "classnames";
import { DownloadableDocument } from "components";
import { isValidUrl } from "utils/url";

interface DocumentRowProps extends HTMLAttributes<HTMLAnchorElement> {
  label: string;
  url: string;
}

export const DocumentRow = (props: DocumentRowProps) => {
  const validUrl = isValidUrl(props.url);
  return (
    <DownloadableDocument
      className={classNames("pt-3 pb-3", {
        "cursor-default pointer-events-none": !validUrl,
      })}
      validUrl={validUrl}
      {...props}
    />
  );
};
